import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { AffiliateSideNav } from "./affiliateSideNav.js";
import { AffiliateStatStrip } from "./affiliateStatStrip.js";
import { AffiliateSignupErrorState } from "./signup/affiliateSignupErrorState.js";
import { AffiliateSignupForm } from "./signup/affiliateSignupForm.js";
import { AffiliateSignupPendingState } from "./signup/affiliateSignupPendingState.js";
import { trackAnalyticsEvent } from "../../../../../others/tracking.js";
import { useStores } from "../../../../../store/stores.js";
import { AccountSkeleton } from "../../accountSkeleton.js";
const AffiliateTab = observer(()=>{
    const { accountV2Store: { session } } = useStores();
    const isOnDashboard = !!session?.affiliate;
    useEffect(()=>{
        if (isOnDashboard) {
            trackAnalyticsEvent("affiliate_dashboard_loaded", {
                ga: {
                    event_category: "account",
                    event_label: "Affiliate dashboard loaded"
                },
                matomo: {
                    category: "account",
                    name: "Affiliate dashboard loaded"
                }
            });
        }
    }, [
        isOnDashboard
    ]);
    if (!session) {
        return /*#__PURE__*/ _jsx(AccountSkeleton, {});
    }
    const { canSignUpAsAffiliate, affiliateError, affiliate } = session;
    if (canSignUpAsAffiliate) {
        return /*#__PURE__*/ _jsx(AffiliateSignupForm, {});
    }
    if (affiliateError?.hasErrorCode("AffiliateStatusIsPending")) {
        return /*#__PURE__*/ _jsx(AffiliateSignupPendingState, {});
    }
    if (affiliateError) {
        return /*#__PURE__*/ _jsx(AffiliateSignupErrorState, {
            error: affiliateError
        });
    }
    if (affiliate) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "rc-account-v2-affiliate-dashboard",
            children: [
                /*#__PURE__*/ _jsx(AffiliateStatStrip, {
                    affiliate: affiliate
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "rc-account-v2-affiliate-dashboard__body",
                    children: [
                        /*#__PURE__*/ _jsx(AffiliateSideNav, {}),
                        /*#__PURE__*/ _jsx("div", {
                            className: "rc-account-v2-affiliate-dashboard__content",
                            children: /*#__PURE__*/ _jsx(Outlet, {})
                        })
                    ]
                })
            ]
        });
    }
    return null;
});
export { AffiliateTab };
